const INITIAL_CHECKER_HELP_LINK =
  'https://help.venngage.com/hc/en-us/articles/11013169543693-Start-here-accessibility-terms-and-basics';
const DOWNLOAD_MODAL_HELP_LINK =
  'https://help.venngage.com/hc/en-us/articles/11013169543693-Start-here-accessibility-terms-and-basics';
const PPT_DOWNLOAD_HELP_LINK =
  'https://help.venngage.com/hc/en-us/articles/11013594400269-Edit-a-presentation-or-slide-deck-from-Venngage-in-another-app#my-fonts-changed-when-i-opened-the-design-in-powerpoint-what-should-i-do';
const READING_ORDER_HELP_LINK =
  'https://help.venngage.com/hc/en-us/articles/9738540832653-Use-Reading-Order-in-your-accessible-designs-and-documents';
const DOCUMENT_LANGUAGE_HELP_LINK =
  'https://help.venngage.com/hc/en-us/articles/11013042491789-Identify-the-document-language';
const DOCUMENT_TITLE_HELP_LINK =
  'https://help.venngage.com/hc/en-us/articles/10363823118861-Title-your-design-with-accessibility-in-mind';
const ALTERNATIVE_TEXT_HELP_LINK =
  'https://help.venngage.com/hc/en-us/articles/9738531806861-Write-helpful-alternative-alt-text-for-non-text-content';
const IMAGE_OF_TEXTS_HELP_LINK =
  'https://help.venngage.com/hc/en-us/articles/11013109984397-Use-text-instead-of-images-of-text';
const HEADINGS_HELP_LINK =
  'https://help.venngage.com/hc/en-us/articles/11013111184269-Create-and-tag-headings-and-titles-for-accessibility';
const COLOR_CONTRAST_HELP_LINK =
  'https://help.venngage.com/hc/en-us/articles/9738531620237-Using-color-contrast-for-accessibility';
const USE_OF_COLOR_HELP_LINK =
  'https://help.venngage.com/hc/en-us/articles/11013077501709-Convey-meaning-without-relying-on-color';
const LINKS_HELP_LINK =
  'https://help.venngage.com/hc/en-us/articles/11013073045133-Style-links-to-make-them-more-accessible';
const TABLES_HELP_LINK = 'https://help.venngage.com/hc/en-us/articles/9738538155533-Designing-an-accessible-table';
const PRIVATELINK_REPORT_LINK = 'https://venngage.typeform.com/to/xOUCTk?referrer=';
const PRIVATELINK_DMCA_POLICY_LINK =
  'https://help.venngage.com/en/articles/5773727-venngage-dmca-policy-copyright-infringement';

const UPGRADE_REDIRECT_LINK = '/account/subscription';
const UPGRADE_REDIRECT_BIZ_LINK = '/account/subscription/business';

const BRAND_REDIRECT_LINK = '/infographics/my_brand';
const MY_DESIGN_REDIRECT_LINK = '/infographics';
const TEMPLATES_REDIRECT_LINK = '/templates';

const TEAM_DESIGN_REDIRECT_LINK = '/infographics/shared_with_me';
const INVITE_TEAM_REDIRECT_LINK = '/infographics/my_team';

const SIGN_UP_LINK = '/register';

const S3_BRAND_MEDIA_BUCKET_LINK = process.env.REACT_APP_S3_BRAND_MEDIA_BUCKET_LINK;

export {
  BRAND_REDIRECT_LINK,
  INITIAL_CHECKER_HELP_LINK,
  DOWNLOAD_MODAL_HELP_LINK,
  PPT_DOWNLOAD_HELP_LINK,
  READING_ORDER_HELP_LINK,
  DOCUMENT_LANGUAGE_HELP_LINK,
  DOCUMENT_TITLE_HELP_LINK,
  ALTERNATIVE_TEXT_HELP_LINK,
  IMAGE_OF_TEXTS_HELP_LINK,
  HEADINGS_HELP_LINK,
  MY_DESIGN_REDIRECT_LINK,
  TEAM_DESIGN_REDIRECT_LINK,
  INVITE_TEAM_REDIRECT_LINK,
  S3_BRAND_MEDIA_BUCKET_LINK,
  COLOR_CONTRAST_HELP_LINK,
  USE_OF_COLOR_HELP_LINK,
  LINKS_HELP_LINK,
  TABLES_HELP_LINK,
  PRIVATELINK_REPORT_LINK,
  PRIVATELINK_DMCA_POLICY_LINK,
  UPGRADE_REDIRECT_LINK,
  UPGRADE_REDIRECT_BIZ_LINK,
  TEMPLATES_REDIRECT_LINK,
  SIGN_UP_LINK,
};
